import {createSelector} from '@ngrx/store';
import {AppState} from '../app-state';

export const selectWikiState = (state: AppState) => state.wiki;

export const selectWikiList = createSelector(selectWikiState, state => state.wikiList);
export const selectWikiLoading = createSelector(selectWikiState, state => state.loading);
export const selectWikiItem = createSelector(selectWikiState, state => state.wikiItem);
